/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import Passport from "./Passport.container";

export default Passport;
